module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vgal7-d312d30ce4e9dc96b23b7d330126204a.jpg";